import { KeyValue } from '@angular/common';
import { ClientStatus } from '../enums/client-status.enum';

export const CLIENT_STATUS_VALUES: KeyValue<ClientStatus, string>[] = [
  {
    key: ClientStatus.ActiveAndPotential,
    value: $localize`:@@app.route.client.status.enums.active-potential:Clientes-Candidatos`
  },
  {
    key: ClientStatus.Active,
    value: $localize`:@@app.route.client.status.enums.active:Clientes`
  },
  {
    key: ClientStatus.Inactive,
    value: $localize`:@@app.route.client.status.enums.inactive:Ex-Clientes`
  },
  {
    key: ClientStatus.Potential,
    value: $localize`:@@app.route.client.status.enums.potencial:Candidatos`
  },
  {
    key: ClientStatus.All,
    value: $localize`:@@app.route.client.status.enums.all:Todos`
  }
] as KeyValue<ClientStatus, string>[];